import { Picture } from './Picture';

export class SchoolEntity {
    id: string;
    name: string;
    picture?: Picture;
    location?: string;
}
